<template>
  <div class="alert_mid">
    <div @click="closeTimer">
      <i v-if="status === 0"
         style="color: rgb(250,95,104)"
         class="iconfont icon-sp_fail"></i>
      <i v-if="status === 1"
         style="color: rgb(75,185,168)"
         class="iconfont icon-gw_pass"></i>
      <i v-if="status === 2"
         style="color: rgb(216,30,6)"
         class="iconfont icon-gw_reject"></i>
      {{alertmiddle}}
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlertMiddle',
  props: {
    alertmiddle: String,
    status: Number
  },
  data() {
    return {
      timer: null
    }
  },
  created() {
    this.timer = setTimeout(this.closeTimer, 3000)
  },
  methods: {
    closeTimer: function() {
      clearTimeout(this.timer)
      this.timer = null
    }
  }
}
</script>

<style lang="scss" scoped>
.alert_mid {
  text-align: center;
  position: fixed;
  top: 30%;
  left: 0;
  width: 100%;
  z-index: 9999;
  div {
    margin: 0 auto;
    color: #eee;
    padding: 0.2rem;
    font-size: 0.28rem;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 0.08rem;
    display: inline-block;
    i {
      font-size: 27px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/AlertMiddle.vue